module.exports = __webpack_public_path__ + "static/media/sdesk_screenshot_withframe_booth.6ff4adef.png";